"use strict";

exports.__esModule = true;
exports.default = exports.getInboxMessage = void 0;

var _getInboxLabel2 = _interopRequireDefault(require("./getInboxLabel"));

var _getInboxBody2 = _interopRequireDefault(require("./getInboxBody"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const getInboxMessage = (_ref) => {
  let message = _ref.message,
      createdAt = _ref.createdAt,
      updatedAt = _ref.updatedAt,
      props = _objectWithoutPropertiesLoose(_ref, ["message", "createdAt", "updatedAt"]);

  const _getInboxLabel = (0, _getInboxLabel2.default)(props),
        label = _getInboxLabel.label,
        labelColor = _getInboxLabel.labelColor;

  const _getInboxBody = (0, _getInboxBody2.default)({
    message
  }),
        text = _getInboxBody.text,
        markdown = _getInboxBody.markdown;

  const datetime = updatedAt || createdAt;
  return _extends({}, props, {
    datetime: datetime,
    message: text,
    markdown: markdown,
    label: label,
    labelColor: labelColor
  });
};

exports.getInboxMessage = getInboxMessage;
var _default = getInboxMessage;
exports.default = _default;